import module from 'colaborador/module'
import template from './template.html'
import * as moment from 'moment'

export class ColaboradorCajaAhorroPrestamosItemAmortizacionComponent {
  data

  $onInit () {
    this.periodoInicial = moment(this.data.fechaInicial).format('D [de] MMMM [del] YYYY')
    this.periodoFinal = moment(this.data.fechaFinal).format('D [de] MMMM [del] YYYY')
  }
}

module.component('colaboradorCajaAhorroPrestamosItemAmortizacion', {
  controller: ColaboradorCajaAhorroPrestamosItemAmortizacionComponent,
  template,
  bindings: {
    fechaMaxima: '<',
    soloLectura: '<',
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/colaborador/components/cajaAhorro/prestamos/item/amortizacion/component.js